import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';

import Page from 'modules/_shared/components/Pages/Page';
import Button from 'modules/_shared/components/Buttons';
import GoBackButton from 'modules/_shared/components/Buttons/GoBackButton';
import PageListHeader from 'modules/_shared/components/Headers/PageListHeader';
import CustomLoading from 'modules/_shared/components/CustomLoading';

import CommunicationDetailsPageBody from './components/CommunicationDetailsPageBody';
import { useCommunicationDetailsPage } from './context/CommunicationDetailsPageContext';

const CommunicationDetails: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useCommunicationDetailsPage();

  const pageActions = [
    <GoBackButton />,
    data.isAdmin && (
      <Button
        icon="ni ni-send"
        onClick={actions.handleNewCommunication}
        disabled={data.isReadOnly}
      >
        {t('NewCommunication')}
      </Button>
    ),
  ];

  return (
    <Page>
      <PageListHeader
        subTitle={t('Communications')}
        description={`${data.societyName} ${t('HaveCommunications', {
          count: data.totalCommunications,
        })}`}
        actions={pageActions}
      />

      <CommunicationDetailsPageBody />

      {data.isLoading && <CustomLoading />}
    </Page>
  );
};

export default CommunicationDetails;
